export default function kitReducer(state = { ...defaultState }, action) {
  let newState = { ...state }
  switch (action.type) {
    case 'SET_KIT_STYLE': {
      const { style, nameOfStyle } = action.payload
      newState.style = style
      newState.nameOfStyle = nameOfStyle
      return newState
    }
    case 'SET_KIT_SIZE': {
      const { size, nameOfSize } = action.payload
      newState.size = size
      newState.nameOfSize = nameOfSize
      return newState
    }
    case 'SET_KIT_FABRICS': {
      const { fabricsSet, fabricsDirection } = action.payload
      newState.fabricsSet = fabricsSet
      newState.fabricsDirection = fabricsDirection
      return newState
    }
    case 'SET_KIT_FILLINGS': {
      const { fillingsSet } = action.payload
      newState.fillingsSet = fillingsSet
      return newState
    }
    case 'SET_KIT_CORDING_FABRICS': {
      const { cordingFabricsSet } = action.payload
      newState.cordingFabricsSet = cordingFabricsSet
      return newState
    }
    case 'SET_KIT_QTY': {
      const { kitQty } = action.payload
      newState.kitQty = kitQty
      return newState
    }
    case 'KIT_RESET': {
      return { ...defaultState }
    }
    default:
      return newState
  }
}

const defaultState = {
  nameOfStyle: null,
  style: null,
  nameOfSize: null,
  size: null,
  fabricsSet: null,
  fabricsDirection: null,
  fillingsSet: null,
  cordingFabricsSet: null,
  kitQty: 1,
}
